import { render } from "./AdicionarExecutante.vue?vue&type=template&id=6f254476&scoped=true"
import script from "./AdicionarExecutante.vue?vue&type=script&lang=js"
export * from "./AdicionarExecutante.vue?vue&type=script&lang=js"

import "./AdicionarExecutante.vue?vue&type=style&index=0&id=6f254476&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f254476"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QForm,QSelect});
